import { render, staticRenderFns } from "./linePointModel.vue?vue&type=template&id=36d8408e&scoped=true&lang=pug&"
import script from "./linePointModel.vue?vue&type=script&lang=js&"
export * from "./linePointModel.vue?vue&type=script&lang=js&"
import style0 from "./linePointModel.vue?vue&type=style&index=0&id=36d8408e&lang=scss&scoped=true&"
import style1 from "./linePointModel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d8408e",
  null
  
)

export default component.exports